import { useState, useContext } from "react";
import {
  Typography,
  Box,
  Grid,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  TableContainer,
  Switch,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useMutation } from "@apollo/client";
// Import from project
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import {
  ButtonCreate,
  PageHeaderTitle,
  SearchTextField,
} from "../../Utils/Component";
import EmptyImage from "../../Assets/empty-image.png";
import EmptyData from "../../Components/Include/EmptyData/EmptyData";
import LoadingPage from "../../Utils/LoadingPage";
import FooterPagination from "../../Utils/FooterPagination";
import useWithDimension from "../../Hooks/useWithDimension";
import OnlineBookForm from "../../Components/OnlineBook/OnlineBookForm";
import OnlineBookAction from "../../Components/OnlineBook/OnlineBookAction";
import useGetOnlineBookPagination from "../../Hooks/useGetOnlineBookPagination";
import { SelectBookGroupFee } from "../../Components/Include/DynamicSelect/DynamicSelect";
import { UPDATE_BOOK_SHOW_ON_MOBILE } from "../../Schema/OnlineBook";
import { currencyFormat } from "../../Function/DynamicFn";

export default function OnlineBook() {
  const { t, setAlert } = useContext(AuthContext);
  const { width } = useWithDimension();

  const [groupFeeVal, setGroupFeeVal] = useState({ id: "", title: "" });
  const [type, setType] = useState("all");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const {
    page,
    limit,
    setPage,
    refetch,
    loading,
    setLoading,
    handleSearch,
    tableData,
    paginationData,
    handleLimit,
  } = useGetOnlineBookPagination({ groupFeeId: groupFeeVal?.id, type: type });

  const [updateBookShowOnMobile] = useMutation(UPDATE_BOOK_SHOW_ON_MOBILE, {
    onCompleted: ({ updateBookShowOnMobile }) => {
      if (updateBookShowOnMobile?.isSuccess) {
        setAlert(true, "success", updateBookShowOnMobile?.message);
        refetch();
      } else {
        setAlert(true, "error", updateBookShowOnMobile?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateBookShowOnMobile({
      variables: {
        id: id,
        showOnMobile: status,
      },
    });
  };

  // console.log("tableData:;", tableData)

  return (
    <div className="page-container">
      <PageHeaderTitle
        classPage={t("class-page-title")}
        classSlash="slash-title"
        routeTo={"/setting"}
        pageTitle={t("page_setting")}
        detailTitle={t("page_online_book")}
      />

      <Box sx={{ marginTop: "20px" }}>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("search")}
            </Typography>
            <SearchTextField
              className={"text-field"}
              handleSearch={handleSearch}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("page_group_fee")}
            </Typography>
            <SelectBookGroupFee
              className={"text-field"}
              buttonAdd={false}
              value={groupFeeVal}
              onChange={(val) =>
                setGroupFeeVal({ id: val?.id, title: val?.title })
              }
            />
          </Grid>

          <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
            <Typography className={t("class-name-text-field-title")}>
              {t("thead_type")}
            </Typography>
            <FormControl fullWidth size="small" className={"text-field"}>
              <Select
                value={type}
                onChange={({ target }) => setType(target?.value)}
              >
                <MenuItem value={"all"}>All</MenuItem>
                <MenuItem value={"NoteMelody"}>Note Melody</MenuItem>
                {/* <MenuItem value={"NoteClaim"}>Note Claim</MenuItem> */}
                <MenuItem value={"NoteAccompaniment"}>
                  Note Accompaniment
                </MenuItem>
                <MenuItem value={"BeginnerGuitar"}>Beginner Guitar</MenuItem>
                <MenuItem value={"GuitarSolo"}>Guitar Solo</MenuItem>
                <MenuItem value={"GuitarFingerstyle"}>
                  Guitar Fingerstyle
                </MenuItem>
                <MenuItem value={"PianoBook"}>Piano Book</MenuItem>
                <MenuItem value={"Lyricsandchord"}>Lyrics and chord</MenuItem>
                <MenuItem value={"ChristianSong"}>Christian Song</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6} sm={6} md={12} lg={3} xl={6}>
            <ButtonCreate
              handleOpen={handleOpen}
              classBtn={"btn-create"}
              classIcon={"icon-add"}
            />
            {open && (
              <OnlineBookForm
                open={open}
                handleClose={handleClose}
                dialogTitle="Create"
                setRefetch={refetch}
              />
            )}
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table">
            <TableHead className="header-row">
              <TableRow>
                <TableCell
                  className={t("class-name-header-title-start")}
                  width={"4%"}
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"18%"}
                >
                  {t("thead_title")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"8%"}
                >
                  {t("thead_profile")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"9%"}
                >
                  {t("thead_type")}
                </TableCell>
                {/* <TableCell
                  className={t("class-name-header-title")}
                  width={"13%"}
                >
                  {t("thead_author")}
                </TableCell> */}
                <TableCell
                  className={t("class-name-header-title")}
                  width={"6%"}
                >
                  {t("thead_pages")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"10%"}
                >
                  {t("thead_payment_status")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"10%"}
                >
                  {t("thead_discount_type")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title")}
                  width={"10%"}
                  align="right"
                >
                  {t("thead_discount_amount")}
                </TableCell>
                {/* <TableCell
                  className={t("class-name-header-title")}
                  width={"18%"}
                >
                  {t("thead_description")}
                </TableCell> */}
                <TableCell className="header-title" align="center" width={"8%"}>
                  {t("thead_show")}
                </TableCell>
                <TableCell
                  className={t("class-name-header-title-end")}
                  width={"5%"}
                  align="right"
                ></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="body">
                <TableRow className="body-row">
                  <TableCell colSpan={12} className="body-cell" align="center">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <TableBody className="body">
                {!tableData || tableData.length === 0 ? (
                  <TableRow className="body-row">
                    <TableCell
                      colSpan={12}
                      className="body-cell"
                      align="center"
                    >
                      <EmptyData />
                    </TableCell>
                  </TableRow>
                ) : (
                  tableData.map((row, index) => (
                    <TableRow className="body-row" key={row?._id || index}>
                      <TableCell className="body-cell-start">
                        {row?.numbering || "-- : --"}
                      </TableCell>
                      <TableCell className="body-cell">
                        {row?.title}: {row?.groupFeeId?.price} $
                      </TableCell>
                      <TableCell className="body-cell">
                        <img
                          alt="lesson-preview"
                          style={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "4px",
                            objectFit: "cover",
                            display: "inline-block",
                            verticalAlign: "middle",
                          }}
                          src={row?.image || EmptyImage}
                        />
                      </TableCell>
                      <TableCell className="body-cell">
                        {row?.type === "NoteMelody" && "Note Melody"}
                        {row?.type === "NoteAccompaniment" &&
                          "Note Accompaniment"}
                        {row?.type === "BeginnerGuitar" && "Beginner Guitar"}
                        {row?.type === "GuitarSolo" && "Guitar Solo"}
                        {row?.type === "GuitarFingerstyle" &&
                          "Guitar Fingerstyle"}
                        {row?.type === "PianoBook" && "Piano Book"}
                        {row?.type === "Lyricsandchord" && "Lyrics and chord"}
                        {row?.type === "ChristianSong" && "Christian Song"}
                      </TableCell>
                      {/* <TableCell className="body-cell">{row?.author}</TableCell> */}
                      <TableCell className="body-cell">{row?.pages}</TableCell>
                      <TableCell className="body-cell">
                        {row?.payStatus === "pay" ? "Pay" : "Free"}
                      </TableCell>
                      <TableCell className="body-cell">
                        {row?.discountType === "amount" ? "Amount" : "Percent"}
                      </TableCell>
                      <TableCell className="body-cell" align="right">
                        {row?.discountType === "amount"
                          ? currencyFormat(row?.discountAmount)
                          : row?.discountAmount}{" "}
                        {row?.discountType === "amount" ? "$" : "%"}
                      </TableCell>
                      {/* <TableCell className="body-cell">{row?.rating}</TableCell> */}
                      {/* <TableCell className="body-cell">
                        {row?.description}
                      </TableCell> */}
                      <TableCell className="body-cell" align="center">
                        <Switch
                          size="medium"
                          checked={row?.showOnMobile}
                          onChange={() =>
                            handleUpdateStatus(row?._id, !row?.showOnMobile)
                          }
                        />
                      </TableCell>
                      <TableCell className="body-cell-end" align="right">
                        <OnlineBookAction
                          setRefetch={refetch}
                          editData={row}
                          pageNum={page}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            )}
          </Table>
        </TableContainer>

        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          setLoading={setLoading}
        />
      </Box>
    </div>
  );
}
